// exportUtils.js
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Sample nested data
// const initialSections1 = [
//   {
//     "Admission ID": "A100",
//     "Name": "Keerthi",
//     "Old Pending": {
//       "Fees": 15000,
//       "Discount": 500,
//       "Paid": 4500,
//       "Pending": 10000
//     },
//     "1st Term": {
//       "Fees": 10000,
//       "Discount": 0,
//       "Paid": 2000,
//       "Pending": 8000
//     }
//   }
// ];

// Flatten nested objects recursively
function flattenObject(obj, prefix = '') {
  const flat = {};
  for (const key in obj) {
    if (
      typeof obj[key] === 'object' && 
      obj[key] !== null && 
      !Array.isArray(obj[key])
    ) {
      Object.assign(flat, flattenObject(obj[key], prefix + key + ' - '));
    } else {
      flat[prefix + key] = obj[key];
    }
  }
  return flat;
}

// Export handler function
export const handleExport = (data, format, fileName = 'Exported_Data') => {
  // Flatten all data rows
 // const flattenedData = data.map(row => flattenObject(row));
  
//const slicedData = flattenedData.slice(0);
  if (format === 'excel') {
    //const worksheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook = XLSX.utils.book_new();
     const ws = XLSX.utils.table_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
    console.log(`Excel file ${fileName}.xlsx generated successfully.`);
  }
  else if (format === 'pdf') {
     const doc = new jsPDF();
    doc.text(fileName, 14, 16);

    // Use the HTML table directly
    autoTable(doc, {
      html: data,  // source = tableRef.current
      startY: 20,
      useCss: true,
      styles: { fontSize: 8 },
    });

    doc.save(`${fileName}.pdf`);
    console.log(`PDF file ${fileName}.pdf generated successfully.`);
  } 
  // else if (format === 'pdf') {
  //   const doc = new jsPDF();
  //   doc.text(fileName, 14, 16);

  //   if (flattenedData.length > 0) {
  //     autoTable(doc, {
  //       head: [Object.keys(flattenedData[0])],
  //       body: flattenedData.map(row => Object.values(row)),
  //       startY: 20,
  //     });
  //   } else {
  //     doc.text('No data to export', 14, 30);
  //   }
  //   doc.save(`${fileName}.pdf`);
  //   console.log(`PDF file ${fileName}.pdf generated successfully.`);
  // }
};

